export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/microsoft.bc4be498.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};